/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 */
import { Container, Row, Col } from "react-bootstrap";
import "./Body.css";
import {
  capitalizeFirstLetter,
} from "../Utils";
import Staff from "../staff/staff.js";

export default function Body({ realtorData, loanOfficerActive, loanOfficerData, angelAiUserInfo }) {

  const realtorName = realtorData ? capitalizeFirstLetter(realtorData.name) : "";
  let loanOfficerName;
  if (loanOfficerActive) {
    loanOfficerName = loanOfficerData ? capitalizeFirstLetter(loanOfficerData.name) : "";
  } else {
    loanOfficerName = angelAiUserInfo ? capitalizeFirstLetter(angelAiUserInfo.angelAIBrandingInfo.brandName) : "";
  }

  return (
    <>
      <div className="banner">
        <Container>
          <Row className="banner-row">
            <Col sm={12} md={12} xl={12} xxl={12} lg={12}>
              <h1 class="lo-name-and-realt">
                <p class="span0">{loanOfficerName} and {realtorName}:<br /></p>
                <p class="span1">Bridging Dreams with Reality in Real Estate</p>
              </h1>
              <img src={`${process.env.REACT_APP_CDN}realtor-investment-loans-cobranding/rectangleLine.webp`} className="rectangleLine" alt=' '></img>
            </Col>
            <div className="staff">
              <Staff
                realtorData={realtorData}
                loanOfficerActive={loanOfficerActive}
                loanOfficerData={loanOfficerData}
                angelAiUserInfo={angelAiUserInfo}
              />
            </div>
          </Row>
        </Container>
      </div >
    </>
  );
}
